export default {"src":"/_next/static/image/src/images/about/red-paw.d232dd2696d756969a9812a51917056c.svg","height":46,"width":46};